import React from 'react';
import { Video } from '../types';

interface VideoBackgroundProps {
  currentVideo: Video | null;
  nextVideo: Video | null;
  primaryVideoActive: boolean;
  isVideoFading: boolean;
}

const VideoBackground: React.FC<VideoBackgroundProps> = ({
  currentVideo,
  nextVideo,
  primaryVideoActive,
  isVideoFading
}) => {
  return (
    <div className="fullscreen-background">
      {currentVideo && (
        <video
          className={`video primary-video ${isVideoFading && primaryVideoActive ? 'fade-out' : ''} ${primaryVideoActive ? 'active' : 'inactive'}`}
          src={currentVideo.downloadUrl}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />
      )}
      {nextVideo && (
        <video
          className={`video secondary-video ${isVideoFading && !primaryVideoActive ? 'fade-out' : ''} ${!primaryVideoActive ? 'active' : 'inactive'}`}
          src={nextVideo.downloadUrl}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />
      )}
    </div>
  );
};

export default VideoBackground; 